import api from "app/api";
import { Options } from "common";
import { ProgramItem } from "features/programs/programApi";

export interface PartnerCommissionItem {
  id: number;
  partner_id: number;
  headcount: number;
  commission_rate: number;
  program_id?: number;
  valid_from?: string;
  program?: ProgramItem;
}

export type PartnerCommissionOptions = Options<"program_id">;

export function getPartnerCommissionService(scope?: any) {
  return api.getService<
    PartnerCommissionItem,
    PartnerCommissionItem,
    PartnerCommissionOptions
  >("partner-commissions", {
    scope,
    //params goes here
  });
}
